import { AxiosError } from 'axios'
import { flow } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { CustomGenerator } from 'Core/interfaces/core'

import { getSuccessMessage } from 'Portals/Customer/constants'
import { Kpi } from 'Portals/Customer/entities'
import { KpiRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

import { LocationByPeriodsTable } from './LocationByPeriodsTable'

export class LocationByPeriodsStore {
	table: LocationByPeriodsTable

	constructor(public rootStore: RootStore) {
		this.table = new LocationByPeriodsTable(rootStore)
	}

	@flow.bound
	*addTerm(
		payload: Kpi.Request.Add
	): CustomGenerator<Kpi.MeasureResponse, Kpi.MeasureResponse | undefined> {
		try {
			const result = yield KpiRepo.addKpi(payload)
			this.rootStore[STORE_UI].showSuccessNotification(getSuccessMessage())
			return result
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	@flow.bound
	*editTerm(payload: Kpi.Request.Edit, kpiId: number, termId: number): CustomGenerator<void> {
		try {
			yield KpiRepo.editKpi(payload, kpiId, termId)
			this.rootStore[STORE_UI].showSuccessNotification(getSuccessMessage())
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}
}
